import React from 'react';
import MuiFade, { FadeProps as MuiFadeProps } from '@mui/material/Fade';

export type FadeProps = MuiFadeProps;

export const Fade = React.forwardRef<HTMLDivElement, FadeProps>((props, ref) => {
  return <MuiFade ref={ref} {...props} />;
});

Fade.displayName = 'Fade';
